<input 
    [attr.aria-label]="monLabel" 
    [disabled]="disable" 
    type="checkbox" 
    (click)="toggleItems()" 
    [appIndeterminate]="hasSomeItems()" 
    [checked]="haveAllItems()"
    [name]="'select-all'"
/>
